module.exports = __webpack_public_path__ + "static/media/logo.c63df381.svg";